import EnUs from './en-us/messages.json'
import EnGb from './en-gb/messages.json'

export default {
  en_US: 'en-US',
  en_GB: 'en-GB',
  messages: {
    en_US: EnUs,
    en_GB: EnGb
  }
}
